export default [
  '$scope',
  '$uibModalInstance',
  'popupService',
  'adAssessmentService',
  'deviceService',
  function ($scope, $uibModalInstance, popupService, adAssessmentService, deviceService) {
    this.isMobile = deviceService.isMobile;

    this.sendText = () => {
      this.form.$setSubmitted(true);
      adAssessmentService
        .sendAssessmentText({
          assessmentText: this.message,
        })
        .then(
          () => {
            $uibModalInstance.dismiss('sent');

            if (deviceService.isMobile) {
              $uibModalInstance.closed.then(() => {
                popupService.openPopup('reportMessageOk');
              });
            } else {
              popupService.openPopup('reportMessageOk');
            }
          },
          () => {
            $uibModalInstance.dismiss('error');

            if (deviceService.isMobile) {
              $uibModalInstance.closed.then(() => {
                popupService.openPopup('reportMessageError');
              });
            } else {
              popupService.openPopup('reportMessageError');
            }
          },
        );
    };
  },
];
